import React, { useEffect, useState } from "react";
import * as CONSTANTS from '../../utils/CONSTANTS'
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import DropDown from '../../components/dropdown';
import { Icon } from "@iconify/react";
import {Grid, GridCellProps, GridColumn as Column, GridDetailRowProps, GridExpandChangeEvent } from "@progress/kendo-react-grid";
import classnames from "classnames";
import ApproveOrReject from '../../modal/company';
import { DropDownInput } from "../../wrappers/selectInput";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { checkCompanyType, makeSideBarActive, companyApprovalAccess, checkSourcedBy } from '../../utils/EllowUtils';
import BlackListCompany from "../../modal/company/blacklist";


export type AllCompaniesFormFields = {
  sourcedBy?: any;
  behalfOf?: any;
  allocatedTo?: any;
}

const dateOfReg = (props: GridCellProps) => {
  let date = props.dataItem.dateOfReg
    ? new Date(parseInt(props.dataItem.dateOfReg)).toDateString()
    : "";
  return <td>{date}</td>;
};

interface Props {
  companyData?: any;
  total?: any
  approveOrRejectCustomer?: any;
  handlePageChange?: any;
  setSort?: any;
  applySort?: any;
  submitSourcedBy?: any;
  allocatedToList?: any;
  SubmitCustomerAllocation?: any;
  type?: string;
  blackListCustomer?: any;
}

const validationSchema = Yup.object({

});

const AllCompanies: React.FC<Props> = (
  {
    companyData,
    total,
    approveOrRejectCustomer,
    handlePageChange,
    setSort,
    applySort,
    submitSourcedBy,
    allocatedToList,
    blackListCustomer,
    SubmitCustomerAllocation,
    type
  }
) => {

  const formOptions = {
    resolver: yupResolver(validationSchema)
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<AllCompaniesFormFields>(formOptions);


  const customerId = localStorage.getItem('customerId') || ''
  const userLoginId = localStorage.getItem('loginId')
  const Email = localStorage.getItem('Email')
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3)
  
  const [modal, setModal] = useState<boolean>(false)
  const [data, setData] = useState<any>()
  const [companyList, setCompanylist] = useState<any>()
  const [selected, setSelected] = useState<number>(0)
  const [show, setShow] = useState<boolean>()
  const [count, setCount] = useState<any>()
  const [pageSize, setPageSize] = useState<number>(25)
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [rejectVariable, setRejectVariable] = useState<boolean>()
  const [companyId, setCompanyId] = useState<any>(null)
  const [blackList, setBlackList] = useState<boolean>(false)

  useEffect(() => { 
    
    setCompanylist(companyData)
    setCount(total)

  }, [companyData, total])

  useEffect(() => {
    
    submitAllocatedTo(watch())

  }, [watch().allocatedTo])

  
  const submitAllocatedTo = (data: any) => {
 
    let value = {
      "customerId": companyId,
      "allocationId": data && data.allocatedTo && data.allocatedTo.id,
      "userLoginId": userLoginId 
    }
    if(data && data.allocatedTo){
      setCompanyId(null)
      setValue("allocatedTo",null)
      SubmitCustomerAllocation(value)
    }
  }

  const approve = (data: any) => {

    let companyApprovalRejectAccess  = companyApprovalAccess(data.companyType)

    let value = {
      "customerId": data.companyId,
      "userLoginId": userLoginId,
      "customerStatus": 4,
      "companyType": data.companyType,
      "customerName": data.companyName
    }
    setRejectVariable(false)
    setData(value)
    if(companyApprovalRejectAccess === true ){
      setModal(true)
    }
  }

  const reject = (data: any) => {
  
    let companyApprovalRejectAccess  = companyApprovalAccess(data.companyType)

    let value = {
      "customerId": data.companyId,
      "userLoginId": userLoginId,
      "customerStatus": 5,
      "companyType": data.companyType,
      "customerName": data.companyName
    }
    setRejectVariable(true)
    setData(value)
    if(companyApprovalRejectAccess === true ){
      setModal(true)
    }
  }

  const submitCustomerStatus = (value: any) => {
    if(value === undefined){
      approveOrRejectCustomer(data)
    }else{
      data.rejectComment = value.rejectComment
      approveOrRejectCustomer(data)
    }
  }

  const datachange = (e: any) => {
    setPageSize(e.value)
    handlePageChange(e.value, pageNumber)
  }

  const pageChange = (decision: string) => {
    let page = pageNumber
    if (decision === 'Add') {
      setPageNumber(pageNumber + 1)
      page = page + 1
    } else {
      setPageNumber(pageNumber - 1)
      page = page - 1
    }
    handlePageChange(pageSize, page)
  }
  //vishnu
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const companySettings = (item: any) => {
    localStorage.setItem('CompanySettings', JSON.stringify(item))
    openInNewTab(`${window.location.origin}/companysettings`)
    //  navigate('/companysettings', { state: { data: item } })
  }

  const submit = (data: any) => {
    let value = {
      "customerId": customerId,
      "userLoginId": userLoginId,
      "sourcedBy": data.sourcedBy,
      "behalfOf": data.behalfOf
    }
    submitSourcedBy(value)
  }

  const changeAllocatedTo = (companyId: any) => {

    if(Email === 'jjoseph@ellow.io' || Email === 'vismaya.manoj@ellow.io' || Email === 'varun.v@ellow.io' || Email === 'aparna.vuke@ellow.io' ){
      setCompanyId(companyId)
    }
  }

  const blackListCompany = (data: any) => {
    setBlackList(false)
    let value = {
      "userLoginId": userLoginId,
      "customerId": companyId,
      "comment": data.blacklistComment
  }
    blackListCustomer(value)
    
  }

  const locations = (props: any) => {
  
    return ( 
      <td>
        {props.googleLocations && props.googleLocations.length > 0 ? props.googleLocations.map((item: any, key:number) => {
          return(
            <div  key={key} className="positionList">
              <span className="status warning" />
              <strong>{item}</strong>    
            </div>
          )
        }) : 'Not Mentioned'}
      </td>
    )
  }

  return (
    <>
      <div className={Styles.companyList} >
        <div className={Styles.companySort}>
        </div>
        <div className="staticPagination">
          <a href=" " className={pageNumber === 1 ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the previous page">
            <span className="k-icon k-i-arrow-60-left" onClick={(e) => { pageChange('Remove'); e.preventDefault() }}></span>
          </a>
          <a href=" " className={((pageNumber - 1) * pageSize + 1 >= count || count <= pageSize) ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the next page">
            <span className="k-icon k-i-arrow-60-right" onClick={(e) => { pageChange('Add'); e.preventDefault() }}></span>
          </a>
          Rows per page: <DropDown data={[25, 50, 100]} defaultValue="25" onChange={(e: any) => datachange(e)} /> {`${pageNumber === 1 ? 1 : (pageNumber - 1) * pageSize + 1}-${count < pageSize ? count : pageSize < ((pageNumber - 1) * pageSize + 1) ? ((pageNumber) * pageSize) : pageSize} of ${count}`}
        </div>
        {companyList && companyList.map((item: any, key: number) => {

          let currentDate = new Date().getTime()
          let dateOfRegistration = item.userDetails && item.userDetails[0] !== undefined ? item.userDetails[0].dateOfReg : 0
          var diff = (currentDate - dateOfRegistration) / 1000;
          diff /= (60 * 60);
          let diff2 = Math.abs(Math.round(diff))

          return (
            <div
              key={key}
              className={classnames(
                selected === key && show
                  ? Styles.itemActive
                  : Styles.itemInactive
              )}
            >
              <div className={Styles.companyItem}>
                <div className={Styles.infoCard}>
                  <div className="statusWrap">
                    {diff2 <= 24 && (
                      <span className={Styles.userStatus}>New</span>
                    )}
                  </div>
                  <figure>
                    <img alt="" src="https://via.placeholder.com/150/0000FF/FFFFFF/?text=Digital.com" />
                  </figure>
                  <h4>
                    Company Name
                    <span>{item.companyName}</span>
                  </h4>
                </div>
                <div className={Styles.infoCard}>
                  <figure>
                    <Icon icon="material-symbols:category-outline" />
                  </figure>
                  <h4>
                    Type
                    <span>{checkCompanyType(item.companyType)}</span>
                  </h4>
                </div>
                <div className={Styles.infoCard}>
                  <figure>
                    <Icon icon="lucide:user" />
                  </figure>
                  <h4>
                    Verified By
                    <span>{item.verifiedByName !== null ? item.verifiedByName : 'Not mentioned'}</span>
                  </h4>
                </div>
                <div className={Styles.infoCard}>
                  <figure>
                    <Icon icon="lucide:award" /> 
                  </figure>
                  <h4>
                    Status
                    <span
                      className={
                        item.customerStatus === 4
                          ? Styles.statusApproved
                          : Styles.statusRejected
                      }
                    >
                      {item.customerStatus === 4 ? "Approved" : item.customerStatus === 9 ? "Blacklisted" : "Rejected"}
                    </span>
                  </h4>
                </div>

                {( type === 'approved' || type === 'blacklisted') && <div className={Styles.infoCard}>
                  <figure>
                    <Icon icon="uil:users-alt" />
                  </figure>
                  <h4>
                    Sourced by
                    <span>
                      {item.sourcedBy ? checkSourcedBy(item.sourcedBy) + ' - ' + item.behalfOfName : 'Not mentioned'}
                    </span>
                  </h4>
                </div>}

                {(item.customerStatus === 4 || type === 'blacklisted') &&
                   <div className={Styles.infoCard}>
                   <h4>
                     Allocated To
                     <div>
                       {item.companyId === companyId ?
                         <DropDownInput<AllCompaniesFormFields>
                           name="allocatedTo"
                           data={allocatedToList}
                           register={register}
                           errors={errors}
                           control={control}
                           textField='name'
                           dataItemKey='id'
                         /> :  
                         <div onClick={() =>{changeAllocatedTo(item.companyId)}}><span>{item.allocated_name !== " " ? item.allocated_name  : "Not Mentioned" }</span></div>
                     } 
                     </div> 
                   </h4>
                 </div>
                }
                {type !== 'blacklisted' && <div className={Styles.infoCard}>
                  <div className="likeAndDislike">
                    {item.activeStatus === 4 ? (
                      <Button
                        onClick={() => {
                          reject(item);
                        }}
                      >
                        <Icon icon="bx:dislike" className="dislike" />
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          approve(item);
                        }}
                      >
                        <Icon icon="bx:like" />
                      </Button>
                    )}
                    <Button
                      onClick={() => {
                        companySettings(item);
                      }}
                    >
                      <Icon icon="tabler:settings" />
                    </Button>
                    {item.companyType === 2 && type === 'approved' &&
                      <Button
                        onClick={() => {
                          setBlackList(true);
                          setCompanyId(item.companyId)
                        }
                        } 
                    >
                      <Icon style={{'color': 'grey', 'fontSize':'30px'}} icon="mdi:user-block-outline" />
                    </Button>
                    }
                  </div>
                </div>}
                <div className={Styles.actionButton}>
                  {selected === key && show ? (
                    <Button
                      onClick={() => {
                        setShow((prev) => !prev);
                        setSelected(key);
                      }}
                    >
                      <Icon icon="akar-icons:minus" />
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        setSelected(key);
                        setShow(true);
                      }}
                    >
                      <Icon icon="akar-icons:plus" />
                    </Button>
                  )}
                </div>
              </div>
              <div className={Styles.detailtable}>

                <section className="tableStyle no-padd-top">
                  <Grid
                    data={item.userDetails && item.userDetails.length > 0 && item.userDetails.filter((values: { primary: boolean; }) => values.primary === true)}>
                    <Column field="firstName" title="Name" />
                    <Column field="userEmail" title="Email" />
                    <Column field="userPhoneNumber" title="Phone" />
                    <Column field="dateOfReg" title="Date of Registration" cell={(props: GridCellProps) => dateOfReg(props)} />
                    <Column field="googleLocation" title="Locations" cell={(props: GridCellProps) => locations(item)} />
                  </Grid>
                  
                </section>
              </div>
            </div>
          );
        })
        }
        {blackList && <BlackListCompany onClose={() => setBlackList(false)} Clickhandler={blackListCompany} />}
        {modal && <ApproveOrReject onClose={() => setModal(false)} submitCustomerStatus={submitCustomerStatus} reject={rejectVariable} />}
      </div>
    </>
  )
}
export default AllCompanies